import {api, getApiError, handleApiError, ServiceResponse} from "../ApiClient";

export type Payment = {
    status: string;
    amount: string;
    userId: string;
};

export interface CheckoutSessionResponse extends ServiceResponse {
    checkout?: {
        url: string
    }
}

export interface PaymentResponse extends ServiceResponse {
    payment?: Payment
}

export const PaymentService = () => {

    const create = async (amount: number, userId: string, caddieId: string): Promise<CheckoutSessionResponse> => {
        const source = window.location.host.includes("staging-player") ? "PLAYER_WEB_STG" : "PLAYER_WEB_PROD";

        return api.post<{url: string}>(`/api/1/player-payments`, {
            userId,
            caddieId,
            amount,
            source
        })
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        checkout: resp.data
                    }
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    }

    const getAndRectify = async (paymentId: string): Promise<PaymentResponse> => {
        return api.get<Payment>(`/api/1/player-payments/${paymentId}?rectify=true`)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        payment: resp.data
                    }
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    }


    return {
        createPayment: create,
        getAndRectifyPayment: getAndRectify
    }
}
